import { defineStore } from 'pinia'
import api, { listMyServices, getMyAvailability } from '@/services/api'

export const useProviderOnboardingStore = defineStore('providerOnboarding', {
  state: () => ({
    profile: null,
    services: null,      // null = não carregado ainda | [] = sem serviços | [...] = tem serviços
    availability: null,  // null = não carregado ainda | [] = sem registros | [...] = tem registros
    loaded: false,
    loading: false,
  }),

  getters: {
    isPresential: (state) => {
      return state.profile?.provider_type === 'presential' || state.profile?.provider_type === 'both'
    },

    needsLocation: (state) => {
      if (state.profile?.provider_type !== 'presential' && state.profile?.provider_type !== 'both') return false
      const lat = state.profile?.latitude
      const lng = state.profile?.longitude
      return lat == null || lng == null || String(lat).trim() === '' || String(lng).trim() === ''
    },

    needsServices: (state) => {
      if (state.profile?.provider_type !== 'presential' && state.profile?.provider_type !== 'both') return false
      if (!Array.isArray(state.services)) return false
      return state.services.filter(s => s.is_active).length === 0
    },

    needsSchedule: (state) => {
      if (state.profile?.provider_type !== 'presential' && state.profile?.provider_type !== 'both') return false
      if (!Array.isArray(state.availability)) return false
      return state.availability.length === 0 || state.availability.every(d => !d.is_active)
    },
  },

  actions: {
    async load () {
      if (this.loaded || this.loading) return

      const userData = (() => {
        try { return JSON.parse(localStorage.getItem('userData') || 'null') } catch { return null }
      })()

      if (!userData?.token) {
        this.loaded = true
        return
      }

      this.loading = true

      try {
        const { data } = await api.get('/users/profile')
        this.profile = data.data || data

        const pt = this.profile?.provider_type
        if (pt === 'presential' || pt === 'both') {
          const [svcs, avail] = await Promise.all([
            listMyServices().then(r => r.data?.data ?? []).catch(() => []),
            getMyAvailability().then(r => r.data?.data ?? []).catch(() => []),
          ])
          this.services = svcs
          this.availability = avail
        }
      } catch {
        this.profile = null
      } finally {
        this.loading = false
        this.loaded = true
      }
    },

    async refresh () {
      this.loaded = false
      this.loading = false
      this.services = null
      this.availability = null
      await this.load()
    },

    reset () {
      this.profile = null
      this.services = null
      this.availability = null
      this.loaded = false
      this.loading = false
    },
  },
})
